// CmcUsageWidget/CmcUsageCache.js
// Normal Cache — CacheBase2 with rk-array, singleton export (Engine Pattern rk=f03ae8b6).
// Holds the normalized usage items, keyed on rk (the field name, e.g. Month_CreditsUsed).
import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'CmcUsageCache';

class CmcUsageCache extends CacheBase2 {
    initialize() {
        this._name = _name;
    }
}

const cmcUsageCache = new CmcUsageCache();
export default cmcUsageCache;
